/**
 * Links externos do clube.
 *
 * Centralizados aqui porque o convite da comunidade aparece em três
 * telas (home, FAQ e sobre) e é o tipo de URL que muda sem aviso —
 * quando o grupo enche, o WhatsApp obriga a criar outro e gerar um
 * convite novo. Com o link num lugar só, essa troca é uma linha.
 *
 * Mantido idêntico ao que já existe em ReadingShowcaseView, inclusive
 * os parâmetros de origem do WhatsApp.
 */
export const LINK_COMUNIDADE_WHATSAPP =
  'https://chat.whatsapp.com/ECWRWKxIwZOE8ccqDXITSb?s=cl&p=i&ilr=0&amv=0';
